<template>
  <div class="trip-detail">
    <div class="navigation-spacer"></div>
    <div class="container">
      <a href="#" @click="$router.back()" class="btn btn-text-gradient-dark"><h3><i class="material-icons">keyboard_arrow_left</i>{{ KriensTourismus.languageKeys['back-to-home'] }}</h3></a>
    </div>
    <div v-if="trip" class="trip-detail__intro page-component container">
      <prismic-image :field="trip.thumbnail"></prismic-image>
      <h1>{{ trip.title[0].text }}</h1>
      <p class="lead-text"><prismic-rich-text :field="trip.description"/></p>
    </div>
    <div class="trip-detail__map page-component container-xl">
      <div id="leaflet-trip-map"></div>
    </div>
    <div v-if="trip" class="trip-detail__list page-component container">
      <div class="trip-detail__list-item"
          v-for="(stationItem, index) in trip.station"
          :key="stationItem.stationtitle + index"
      > 
        <div class="trip-detail__list-index">
          {{ index + 1 }}
        </div>
        <div v-if="stationItem.image" class="trip-detail__list-item-content-wrapper">
          <div class="trip-detail__list-item-image">
            <prismic-image :field="stationItem.image"></prismic-image>
          </div>
          <div class="trip-detail__list-item-content">
            <h2>{{ stationItem.stationtitle[0].text }}</h2>
            <p>{{ $prismic.richTextAsPlain(stationItem.stationdescription) }}</p>
            <prismic-link v-if="stationItem.link.url"
                    class="btn-read-more"
                    :field="stationItem.link" target="_blank">{{ KriensTourismus.languageKeys['to-website'] }}
            </prismic-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../EventBus'
import Card from '../elements/Card.vue'

import L from 'leaflet'

export default {
  name: 'TripDetail',
  props: ['uid'],
  components: {
    Card
  },
  data () {
    return {
      trip: null,
      tripMap: null,
      pointLayer: null,
      lineLayer: null,
      allMarkers: []
    }
  },
  methods: {
    async getContent(language) {
      let document = 	await this.$prismic.client.getByUID('trip', this.uid, { lang : language })
      if (document) {
        this.trip = document.data
      }
      this.initMap()
    },
    initMap () {
      this.tripMap = L.map('leaflet-trip-map').setView([47.0355841,8.2924322], 13.5)
      L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
        maxZoom: 18,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.tripMap)
      this.tripMap.scrollWheelZoom.disable()
      this.tripMap.once('focus', function() { this.tripMap.scrollWheelZoom.enable() })
      this.pointLayer = L.layerGroup().addTo(this.tripMap)
      this.lineLayer = L.layerGroup().addTo(this.tripMap)
      this.setMapPoints()
      this.drawMapLines()
    },
    setMapPoints () {
      this.pointLayer.clearLayers()
      this.allMarkers = []
      let i = 1
      for (let stationItem of this.trip.station) {
        let icon = L.divIcon({
          className: 'leaflet-map-icon-active icon-number-' + i,
          iconSize:     [25, 25],
          iconAnchor:   [12, 12],
        })
        let marker = L.marker([stationItem.position.latitude, stationItem.position.longitude], {icon: icon}).addTo(this.pointLayer)
        this.allMarkers.push(marker)
        i++
      }
      let group = new L.featureGroup(this.pointLayer.getLayers())
      this.tripMap.fitBounds(group.getBounds(), {padding: [10,10]})
    },
    drawMapLines () {
      this.lineLayer.clearLayers()
      for (let i = 0; i < this.allMarkers.length; i++) {
        if (this.allMarkers[i+1]) {
          let lineCords = []
          lineCords.push(this.allMarkers[i].getLatLng())
          lineCords.push(this.allMarkers[i+1].getLatLng())
          L.polyline(lineCords, {color: '#ff6786'}).addTo(this.lineLayer)
        }
      }
    }
  },
  async created() {
    await this.getContent(window.KriensTourismus.language)

    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  }
}
</script>
